import { ref, get } from "firebase/database";
import { db } from "../firebaseConfig";
import { ItemInfo } from "../../models/item";

export const getItems = async (): Promise<{ [key: string]: ItemInfo }> => {
	try {
		const itemsRef = ref(db, "items");
		const snapshot = await get(itemsRef);

		if (!snapshot.exists()) {
			return {};
		}

		const itemsData = snapshot.val();
		// Filter out soft-deleted items
		const filteredItems: { [key: string]: ItemInfo } = {};
		Object.entries(itemsData).forEach(([key, item]: [string, any]) => {
			if (!item.isDeleted) {
				filteredItems[key] = item;
			}
		});
		return filteredItems;
	} catch (error) {
		console.error("Error fetching items:", error);
		throw error;
	}
};

export const getItemsIncludingDeleted = async (): Promise<{
	[key: string]: ItemInfo;
}> => {
	try {
		const itemsRef = ref(db, "items");
		const snapshot = await get(itemsRef);

		if (!snapshot.exists()) {
			return {};
		}

		const itemsData = snapshot.val();

		return itemsData;
	} catch (error) {
		console.error("Error fetching items:", error);
		throw error;
	}
};

/**
 * Get total count of items in the database
 * @returns Total number of items
 */
export const getTotalItemsCount = async (): Promise<number> => {
	try {
		const itemsRef = ref(db, "items");
		const snapshot = await get(itemsRef);

		if (!snapshot.exists()) {
			return 0;
		}

		const itemsData = snapshot.val();
		return Object.keys(itemsData).length;
	} catch (error) {
		console.error("Error fetching items count:", error);
		throw error;
	}
};
